import { Control, Controller } from "react-hook-form";

import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";

import { lossTypes } from "./lossTypes";
import { LossLocationControlLabel } from "./LossLocationControlLabel";

interface LossTypeRadioGroupProps<TValues> {
  control: Control<TValues>;
  name: string;
}

export function LossTypeRadioGroup<TValues>({
  control,
  name,
}: LossTypeRadioGroupProps<TValues>) {
  return (
    <Controller
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      name={name as any}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <FormLabel error={!!error}>What kind of loss occurred?</FormLabel>
            <RadioGroup
              {...field}
              sx={(theme) => ({
                marginLeft: theme.spacing(-0.5),
              })}>
              {lossTypes.map(({ value, label, image, tooltip }) => (
                <LossLocationControlLabel
                  key={value}
                  value={value}
                  image={image}
                  label={label}
                  tooltip={tooltip}
                  hasError={!!error}
                  control={<Radio sx={{ display: "none" }} />}
                />
              ))}
            </RadioGroup>
          </>
        );
      }}
    />
  );
}
